export default __webpack_public_path__ + "static/media/wish.cba12d3c.png";